import {ImageRequestParams} from "../../../../infrastructure/models/params/image-request-params";
import {BaseMetadataModel} from "../../../../infrastructure/models/base-metadata-model";

export class StoreImageRequestParams extends ImageRequestParams {
  id: Number;

  constructor(storeName: String, metaData: BaseMetadataModel, width: Number = 32, height: Number = 32) {
    super({resourceName: 'Website/Store', metaData, width, height});

    this.storeName = storeName;
    this.ratio = 3;
  }

  toString(): String {
    const url = super.toString() + '/' + this.storeName;

    return url;
  }
}
